export const emailOuCPFRegex =
  /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|(\d{3}[-.]?\d{3}[-.]?\d{3}[-.]?\d{2}))$/

export const PERIODOS = [
  {
    label: 'Pós-reforma',
    value: 'REFORMA',
  },
  {
    label: 'Pré-reforma',
    value: 'PRE_REFORMA',
  },
  {
    label: 'Regra de transição',
    value: 'TRANSICAO',
  },
]

export const tiposDeAcao = [
  { value: 'CONCESSAO', label: 'Concessão' },
  { value: 'RESTABELECIMENTO', label: 'Restabelecimento' },
  { value: 'REVISAO', label: 'Revisão' },
  { value: 'OUTROS', label: 'Outros' },
]

export const tiposProcesso = [
  { value: 'ADMINISTRATIVO', label: 'Administrativo' },
  { value: 'JUDICIAL', label: 'Judicial' },
  { value: 'OUTROS', label: 'Outros' },
]

export const TIPOS_PETICOES = [
  {
    label: 'Acordo - Contraproposta',
    value: 'ACORDO_CONTRAPROPOSTA'
  },
  {
    label: 'Agravo de Instrumento',
    value: 'AGRAVO_DE_INSTRUMENTO'
  },
  {
    label: 'Agravo Interno',
    value: 'AGRAVO_INTERNO'
  },
  {
    label: 'Agravos',
    value: 'AGRAVOS'
  },
  {
    label: 'Análises de Aposentadoria',
    value: 'ANALISES_DE_APOSENTADORIA'
  },
  {
    label: 'Antecipação de Tutela',
    value: 'ANTECIPACAO_DE_TUTELA'
  },
  {
    label: 'Contestações',
    value: 'CONTESTACOES'
  },
  {
    label: 'Contrarrazões',
    value: 'CONTRARRAZOES'
  },
  {
    label: 'Contrarrazões Administrativas',
    value: 'CONTRARRAZOES_ADMINISTRATIVAS'
  },
  {
    label: 'Cumprimento de sentença',
    value: 'CUMPRIMENTO_DE_SENTENCA'
  },
  {
    label: 'Declarações',
    value: 'DECLARACOES'
  },
  {
    label: 'Defesas Administrativas',
    value: 'DEFESAS_ADMINISTRATIVAS'
  },
  {
    label: 'Embargos',
    value: 'EMBARGOS'
  },
  {
    label: 'Embargos de Declaração',
    value: 'EMBARGOS_DE_DECLARACAO'
  },
  {
    label: 'Embargos Infrigentes',
    value: 'EMBARGOS_INFRIGENTES'
  },
  {
    label: 'Incidente de Uniformização',
    value: 'INCIDENTE_DE_UNIFORMIZACAO'
  },
  {
    label: 'Manifestações',
    value: 'MANIFESTACOES'
  },
  {
    label: 'Petições',
    value: 'PETICOES'
  },
  {
    label: 'Petições Administrativas',
    value: 'PETICOES_ADMINISTRATIVAS'
  },
  {
    label: 'Petições Iniciais',
    value: 'PETICOES_INICIAIS'
  },
  {
    label: 'Propostas de Acordo',
    value: 'PROPOSTA_DE_ACORDO'
  },
  {
    label: 'Recurso de Apelação',
    value: 'RECURSO_DE_APELACAO'
  },
  {
    label: 'Recurso Especial',
    value: 'RECURSO_ESPECIAL'
  },
  {
    label: 'Recurso Extraordinário',
    value: 'RECURSO_EXTRAORDINARIO'
  },
  {
    label: 'Recurso Inominado',
    value: 'RECURSO_INOMINADO'
  },
  {
    label: 'Recursos',
    value: 'RECURSOS'
  },
  {
    label: 'Recursos Administrativos',
    value: 'RECURSO_ADMINISTRATIVO'
  },
  {
    label: 'Réplicas',
    value: 'REPLICAS'
  },
  {
    label: 'Requerimento Administrativo',
    value: 'REQUERIMENTO_ADMINISTRATIVO'
  }
]

export const BENEFICIOS = [
  {
    label: 'Aposentadoria especial',
    value: 'APOSENTADORIA_ESPECIAL'
  },
  {
    label: 'Aposentadoria por idade',
    value: 'APOSENTADORIA_POR_IDADE'
  },
  {
    label: 'Aposentadoria por Idade da Pessoa com Deficiência',
    value: 'APOSENTADORIA_POR_IDADE_DEFICIENCIA'
  },
  {
    label: 'Aposentadoria por incapacidade',
    value: 'APOSENTADORIA_POR_INCAPACIDADE'
  },
  {
    label: 'Aposentadoria por invalidez',
    value: 'APOSENTADORIA_POR_INVALIDEZ'
  },
  {
    label: 'Aposentadoria por tempo de contribuição',
    value: 'APOSENTADORIA_POR_TEMPO_DE_CONTRIBUICAO'
  },
  {
    label: 'Aposentadoria por Tempo de Contribuição da Pessoa com Deficiência',
    value: 'APOSENTADORIA_POR_TEMPO_DE_CONTRIBUICAO_DEFICIENCIA'
  },
  {
    label: 'Auxílio reclusão',
    value: 'AUXILIO_RECLUSAO'
  },
  {
    label: 'Auxílio-Doença',
    value: 'AUXILIO_DOENCA'
  },
  {
    label: 'Benefício Assistencial',
    value: 'ASSISTENCIAL'
  },
  {
    label: 'Pensão por morte',
    value: 'PENSAO_POR_MORTE'
  },
  {
    label: 'Salário maternidade',
    value: 'SALARIO_MATERNIDADE'
  }
]

export const tiposDoenca = [
  {
    tipo: "ACIDENTE_DE_TRABALHO",
    desc: "Sofri um acidente no trabalho e não consigo mais trabalhar",
    next: "pedidoBeneficio",
  },
  {
    tipo: "ACIDENTE_DE_TRABALHO_NO_TRAJETO",
    desc: "Sofri um acidente no trajeto para o trabalho e não consigo mais trabalhar",
    next: "pedidoBeneficio",
  },
  {
    tipo: "DOENCA_COMUM",
    desc: "A doença não tem a ver com o trabalho que eu faço ou fazia, mas mesmo assim hoje não consigo mais trabalhar.",
    next: "pedidoBeneficio",
  },
];

export const SUBTIPOS = [
  {
    label: 'Idade mínima progressiva',
    value: 'IDADE_MINIMA_PROGRESSIVA'
  },
  {
    label: 'Idade mínima progressiva Professor',
    value: 'IDADE_MINIMA_PROGRESSIVA_PROFESSOR'
  },
  {
    label: 'Normal',
    value: 'NORMAL'
  },
  {
    label: 'Pedágio 100%',
    value: 'PEDAGIO_100'
  },
  {
    label: 'Pedágio 100% Professor',
    value: 'PEDAGIO_100_PROFESSOR'
  },
  {
    label: 'Pedágio 50%',
    value: 'PEDAGIO_50'
  },
  {
    label: 'Pessoa com deficiência',
    value: 'DEFICIENCIA'
  },
  {
    label: 'Pontos',
    value: 'NORMAL_PONTOS'
  },
  {
    label: 'Pontos Professor',
    value: 'PROFESSOR_PONTOS'
  },
  {
    label: 'Professor',
    value: 'PROFESSOR'
  },
  {
    label: 'Rural',
    value: 'RURAL'
  }
]

export const estadosCasos = [
  { label: 'Acre', value: 'AC' },
  { label: 'Alagoas', value: 'AL' },
  { label: 'Amapá', value: 'AP' },
  { label: 'Amazonas', value: 'AM' },
  { label: 'Bahia', value: 'BA' },
  { label: 'Ceará', value: 'CE' },
  { label: 'Distrito Federal', value: 'DF' },
  { label: 'Espírito Santo', value: 'ES' },
  { label: 'Goiás', value: 'GO' },
  { label: 'Maranhão', value: 'MA' },
  { label: 'Mato Grosso', value: 'MT' },
  { label: 'Mato Grosso do Sul', value: 'MS' },
  { label: 'Minas Gerais', value: 'MG' },
  { label: 'Pará', value: 'PA' },
  { label: 'Paraíba', value: 'PB' },
  { label: 'Paraná', value: 'PR' },
  { label: 'Pernambuco', value: 'PE' },
  { label: 'Piauí', value: 'PI' },
  { label: 'Rio de Janeiro', value: 'RJ' },
  { label: 'Rio Grande do Norte', value: 'RN' },
  { label: 'Rio Grande do Sul', value: 'RS' },
  { label: 'Rondônia', value: 'RO' },
  { label: 'Roraima', value: 'RR' },
  { label: 'Santa Catarina', value: 'SC' },
  { label: 'São Paulo', value: 'SP' },
  { label: 'Sergipe', value: 'SE' },
  { label: 'Tocantins', value: 'TO' }
]

export const tagsFiltros = [
  {
    tipo: 'TRABALHO_URBANO',
    label: 'Trabalhei somente na cidade.'
  },
  {
    tipo: 'TRABALHO_RURAL',
    label: 'Já trabalhei no meio rural.'
  },
  {
    tipo: 'FORCAS_ARMADAS',
    label: 'Já servi no exército, aeronáutica ou na marinha.'
  },
  {
    tipo: 'SERVICO_PUBLICO',
    label: 'Já trabalhei no serviço público.'
  },
  {
    tipo: 'RECEBEU_BENEFICIO_INSS_NO_PASSADO',
    label: 'Já recebi algum benefício do INSS no passado.'
  },
  {
    tipo: 'NAO_CONTRIBUI_HA_MAIS_DE_6_MESES',
    label: 'Faz mais de 6 meses que não contribuo para o INSS.'
  }
]

export const escolaridade = [
  { value: 'NENHUM', label: 'Nenhum' },
  {
    value: 'ENSINO_FUNDAMENTAL_INCOMPLETO',
    label: 'Ensino Fundamental Incompleto'
  },
  { value: 'ENSINO_FUNDAMENTAL_COMPLETO', label: 'Ensino Fundamental Completo' },
  { value: 'ENSINO_MEDIO_INCOMPLETO', label: 'Ensino Médio Incompleto' },
  { value: 'ENSINO_MEDIO_COMPLETO', label: 'Ensino Médio Completo' },
  { value: 'ENSINO_SUPERIOR_INCOMPLETO', label: 'Ensino Superior Incompleto' },
  { value: 'ENSINO_SUPERIOR_COMPLETO', label: 'Ensino Superior Completo' },
  { value: 'POS_GRADUADO', label: 'Pós Graduado' },
  { value: 'MESTRADO', label: 'Mestrado' },
  { value: 'DOUTORADO', label: 'Doutorado' },
  { value: 'POS_DOUTORADO', label: 'Pós Doutorado' }
]

export const estados = [
  { label: 'Nenhum', value: '' },
  { label: 'Acre', value: 'AC' },
  { label: 'Alagoas', value: 'AL' },
  { label: 'Amapá', value: 'AP' },
  { label: 'Amazonas', value: 'AM' },
  { label: 'Bahia', value: 'BA' },
  { label: 'Ceará', value: 'CE' },
  { label: 'Distrito Federal', value: 'DF' },
  { label: 'Espírito Santo', value: 'ES' },
  { label: 'Goiás', value: 'GO' },
  { label: 'Maranhão', value: 'MA' },
  { label: 'Mato Grosso', value: 'MT' },
  { label: 'Mato Grosso do Sul', value: 'MS' },
  { label: 'Minas Gerais', value: 'MG' },
  { label: 'Pará', value: 'PA' },
  { label: 'Paraíba', value: 'PB' },
  { label: 'Paraná', value: 'PR' },
  { label: 'Pernambuco', value: 'PE' },
  { label: 'Piauí', value: 'PI' },
  { label: 'Rio de Janeiro', value: 'RJ' },
  { label: 'Rio Grande do Norte', value: 'RN' },
  { label: 'Rio Grande do Sul', value: 'RS' },
  { label: 'Rondônia', value: 'RO' },
  { label: 'Roraima', value: 'RR' },
  { label: 'Santa Catarina', value: 'SC' },
  { label: 'São Paulo', value: 'SP' },
  { label: 'Sergipe', value: 'SE' },
  { label: 'Tocantins', value: 'TO' }
]

export const tagsPeticao = [
  { tag: 'TRABALHADOR_RURAL', label: 'Trabalhador Rural' },
  { tag: 'SERVICO_MILITAR', label: 'Serviço Militar' },
  { tag: 'ESCOLA_TECNICA', label: 'Escola Técnica' },
  { tag: 'SERVICO_PUBLICO', label: 'Serviço Público' },
  { tag: 'PESSOA_COM_DEFICIENCIA', label: 'Pessoa com deficiência' },
  { tag: 'TRABALHO_NO_EXTERIOR', label: 'Trabalho no Exterior' },
  { tag: 'CONTRIBUINTE_INDIVIDUAL', label: 'Contribuinte Individual' },
  { tag: 'GPS_NAO_COMPUTADO', label: 'GPS não computado' },
  { tag: 'ATIVIDADE_ESPECIAL', label: 'Atividade Especial' },
  { tag: 'INCAPACIDADE_PARA_TRABALHO', label: 'Incapacidade para o Trabalho' },
  { tag: 'ATIVIDADE_CONCOMITANTE', label: 'Atividades Concomitantes' },
  {
    tag: 'CONTRATO_DE_TRABALHO_COM_ERRO_NO_CNIS',
    label: 'Contrato de - trabalho com erro no CNIS'
  }
]


export const getYearOptions = (startYear: number): { label: string, value: string }[] => {
  const currentYear = new Date().getFullYear()
  const years: { label: string, value: string }[] = []
  for (let year = currentYear; year >= startYear; year--) {
    years.push({ label: year.toString(), value: year.toString() })
  }
  return years
}